import React from "react";

const Morning = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M13.7 8.695a.616.616 0 0 1-.615-.616V5.616a.616.616 0 0 1 1.231 0v2.463a.616.616 0 0 1-.615.616ZM19.644 11.398a.616.616 0 0 1-.437-.178.616.616 0 0 1 0-.869l1.742-1.743a.617.617 0 1 1 .869.869l-1.737 1.742a.615.615 0 0 1-.437.18ZM6.07 24.972a.616.616 0 0 1-.437-.18.616.616 0 0 1 0-.868l1.743-1.742a.616.616 0 0 1 .869.868l-1.743 1.743a.616.616 0 0 1-.431.179ZM5.08 17.317H2.615a.616.616 0 0 1 0-1.232h2.463a.616.616 0 0 1 0 1.232ZM7.813 11.398a.616.616 0 0 1-.437-.178L5.633 9.476a.616.616 0 1 1 .869-.869l1.742 1.743a.616.616 0 0 1 0 .868.615.615 0 0 1-.43.18ZM33.125 21.073a6.275 6.275 0 0 0-4.662-3.079 6.288 6.288 0 0 0-12.373 1.392 5.4 5.4 0 0 0-1.053-.099 5.585 5.585 0 0 0-3.996 1.67 5.72 5.72 0 0 0-1.035 6.589 5.25 5.25 0 0 0 4.76 3.011h13.266a5.827 5.827 0 0 0 5.216-3.19 6.503 6.503 0 0 0-.123-6.294Z"
            fill={fill}
        />

        <path className="u_fill"
              d="M9.753 20.58c.132-.16.267-.313.407-.461a6.837 6.837 0 0 1 4.853-2.033 7.6 7.6 0 0 1 2.161-3.904c.309-.298.643-.568.998-.807a5.543 5.543 0 1 0-8.419 7.206Z"
              fill={fill}
        />
    </svg>
);

export default Morning;
